export const getLumberjackId = (existingLumberjackId?: string): string => {
  if (existingLumberjackId) {
    return existingLumberjackId;
  }

  return `g${crypto.randomUUID()}`;
};
